import { useCallback, useMemo, useState } from 'react'

const useRowSelection = () => {
  const [selected, setSelected] = useState(() => new Set())

  const toggle = useCallback((id) => {
    setSelected(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }, [])

  const toggleAll = useCallback((ids) => {
    setSelected(prev => {
      const allOn = ids.length > 0 && ids.every(id => prev.has(id))
      const next = new Set(prev)
      ids.forEach(id => { if (allOn) next.delete(id); else next.add(id) })
      return next
    })
  }, [])

  const remove = useCallback((ids) => {
    setSelected(prev => {
      const next = new Set(prev)
      ids.forEach(id => next.delete(id))
      return next
    })
  }, [])

  const clear = useCallback(() => setSelected(new Set()), [])

  const isSelected = useCallback((id) => selected.has(id), [selected])
  const allSelected = useCallback((ids) => ids.length > 0 && ids.every(id => selected.has(id)), [selected])
  const someSelected = useCallback((ids) => ids.some(id => selected.has(id)) && !ids.every(id => selected.has(id)), [selected])

  const ids = useMemo(() => [...selected], [selected])

  return { selected, ids, count: selected.size, toggle, toggleAll, remove, clear, isSelected, allSelected, someSelected }
}

export default useRowSelection
